import { PropertyType } from '../../../common';

export const mapApiToEntity = (data: PropertyType): PropertyType => ({
	uid: data.uid,
	token: data.sid,
	tokenExpiration: data.sid_expiration,
});

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	token: data.token,
	email: data.email,
	password: data.password,
	two_step_code: data.two_step_code,
});
